// Footer.js
import React from 'react';
import './footer.css';
import { 
  FaFacebookF, 
  FaTwitter, 
  FaInstagram, 
  FaYoutube, 
  FaLinkedinIn,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt
} from 'react-icons/fa';



function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* LEFT SECTION: Logo + small intro + tagline */}
        <div className="footer-brand">
          <div className="logo-area">
            <div className="logo-icon" aria-label="Lions Club Logo">
              <img src='Lions Club of Colombo Eye Care.png' alt="Lions Club Logo" />
            </div>
            <div className="logo-text">
              LIONS CLUB
              <span className="small-intro">of Colombo Eye Care</span>
            </div>
          </div>
          <div className="tagline">
            “The first specialised lions club in Sri Lanka dedicated to Eye care.”
          </div>
          
          {/* SOCIAL MEDIA ICONS - ADDED HERE */}
   {/* SOCIAL MEDIA ICONS - WITH REACT ICONS */}
          <div className="social-media">
            <a 
              href="https://web.facebook.com/profile.php?id=100065022691228&_rdc=1&_rdr#" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="social-icon facebook" 
              aria-label="Facebook"
            >
              <FaFacebookF />
            </a>
            <a 
              href="https://twitter.com/lionsclubcolombo" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="social-icon twitter" 
              aria-label="Twitter"
            >
              <FaTwitter />
            </a>
            <a 
              href="https://instagram.com/lionsclubcolombo" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="social-icon instagram" 
              aria-label="Instagram"
            >
              <FaInstagram />
            </a>
            <a 
              href="https://linkedin.com/company/lionsclubcolombo" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="social-icon linkedin" 
              aria-label="LinkedIn"
            >
              <FaLinkedinIn />
            </a>
            <a 
              href="https://youtube.com/lionsclubcolombo" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="social-icon youtube" 
              aria-label="YouTube"
            >
              <FaYoutube />
            </a>
          </div>
        </div>

  
        {/* CENTER SECTION: Navigation */}
        <div className="footer-nav">
          <h4>Explore</h4>
          <nav className="nav-links">
            <a href="/">Home</a>
            <a href="/aboutus">About Us</a>
            <a href="/gallery">Gallery</a>
            <a href="/contactus">Contact Us</a>
            <a href="/get-involved-today">Get Involved</a>
          </nav>
        </div>

        {/* RIGHT SECTION: Contact Info with Email Added */}
        <div className="footer-contact">
          <h4>Get in touch</h4>
          

 {/* PHONE CTA */}
      <a href="tel:+94773440937" className="contact-item cta-call">
        <span className="contact-icon">
          <FaPhoneAlt />
        </span>
        <div className="contact-detail">
          <span className="label">Call Us </span>
          <span className="value">+94 77 344 0937</span>
        </div>
      </a>

      {/* EMAIL CTA */}
      <a href="mailto:info@colomboeyecare.lk" className="contact-item cta-email">
        <span className="contact-icon">
          <FaEnvelope />
        </span>
        <div className="contact-detail">
          <span className="label">Email Us </span>
          <span className="value">info@colomboeyecare.lk</span>
        </div>
      </a>



          {/* Address */}
          <div className="address-block">
            <span className="label">Address</span>
            <span className="value">
              932, Maradana Road,<br />
              Colombo 08,<br />
              Sri Lanka
            </span>
          </div>
        </div>
      </div>

      {/* BOTTOM COPYRIGHT with current year */}
      <div className="footer-bottom">
        <span>© {new Date().getFullYear()} Lions Club Of Colombo Eye Care. All rights reserved.  </span>
        {/* <a href="/privacy">Privacy</a> | <a href="/terms">Terms</a> */}
      </div>
    </footer>
  );
}

export default Footer;